import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

import Layout from "./Layout";

import LoginPage from "./pages/LoginPage";
import VendorAddPage from "./pages/VendorAddPage";
import DashboardPage from "./pages/DashboardPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VendorListPage from "./pages/VendorListPage";
import AccessManagement from "./pages/AccessManagementPage";
import VendorViewPage from "./pages/VendorViewPage";
import DropboxConnection from "./pages/DropboxConnection";
import DropboxCronListPage from "./pages/DropboxCronListPage";
import DropboxConnectionViewPage from "./pages/DropboxConnectionViewPage";
import DropboxLogsListPage from "./pages/DropboxLogsListPage";
import DropboxLogViewPage from "./pages/DropboxLogViewPage";
import FTPConnectionPage from "./pages/FTPConnectionPage";
import FTPCronListPage from "./pages/FTPCronListPage";
import FTPConnectionViewPage from "./pages/FTPConnectionViewPage";
import FTPLogViewPage from "./pages/FTPLogViewPage";
import FTPLogsListPage from "./pages/FTPLogsListPage";
import SFTPConnectionPage from "./pages/SFTPConnectionPage";
import SFTPCronListPage from "./pages/SFTPCronListPage";
import SFTPConnectionViewPage from "./pages/SFTPConnectionViewPage";
import SFTPLogViewPage from "./pages/SFTPLogViewPage";
import SFTPLogsListPage from "./pages/SFTPLogsListPage";
import InvoiceCheckPage from "./pages/InvoiceCheckPage";
import UserAddPage from "./pages/UserAddPage";
import UserListPage from "./pages/UserListPage";
import UserViewPage from "./pages/UserViewPage";
import { Clear } from "@mui/icons-material";
import ClearanceLabels from "./pages/ClearanceLabelsPage";
// Create a custom theme
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2", // Primary color
    },
    secondary: {
      main: "#dc004e", // Secondary color
    },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("authToken"));

  useEffect(() => {
    // Listen for localStorage changes
    const handleStorageChange = () => {
      setIsAuthenticated(!!localStorage.getItem("authToken"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ToastContainer />
        <Routes>
        <Route element={<Layout />}>
          <Route path="/vendor/add" element={<VendorAddPage />} />
          <Route path="/vendor/list" element={<VendorListPage />} />
          <Route path="/vendor/:id" element={<VendorViewPage />} />
          <Route path="/connection/dropbox-list" element={<DropboxCronListPage />} />
          <Route path="/connection/dropbox" element={<DropboxConnection />} />
          <Route path="/connection/dropbox/:id" element={<DropboxConnectionViewPage />} />
          <Route path="/dropbox-logs/:id" element={<DropboxLogsListPage />} />
          <Route path="/dropbox-log-view/:id" element={<DropboxLogViewPage />} />

          <Route path="/connection/ftp" element={<FTPConnectionPage />} />
          <Route path="/connection/ftp-list" element={<FTPCronListPage />} />
          <Route path="/connection/ftp/:id" element={<FTPConnectionViewPage />} />
          <Route path="/ftp-logs/:id" element={<FTPLogsListPage />} />
          <Route path="/ftp-log-view/:id" element={<FTPLogViewPage />} />

          <Route path="/connection/sftp" element={<SFTPConnectionPage />} />
          <Route path="/connection/sftp-list" element={<SFTPCronListPage />} />
          <Route path="/connection/sftp/:id" element={<SFTPConnectionViewPage />} />
          <Route path="/sftp-logs/:id" element={<SFTPLogsListPage />} />
          <Route path="/sftp-log-view/:id" element={<SFTPLogViewPage />} />

          <Route path="/access-manage" element={<AccessManagement />} />
          <Route path="/dashboard" element={isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />} />
          <Route path="/invoice-check" element={<InvoiceCheckPage />} />
          <Route path="/clearance-labels" element={<ClearanceLabels />}/>

          <Route path="/user/add" element={<UserAddPage />} />
          <Route path="/user/list" element={<UserListPage />} />
          <Route path="/user/:id" element={<UserViewPage />} />          
          </Route>
          <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/unauthorized" element={<ForbiddenPage />} />


        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
